import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, tap } from "rxjs";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

interface ApiResponse {
    number_error?: number;
    [key: string]: any;
}

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);
    
    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
                // Clone the response to preserve headers
                const clonedResponse = event.clone();
                if ((clonedResponse.body as ApiResponse)?.number_error === 403) {
                    handleExpiredToken(router);
                }
            }
        })
    );
};

function handleExpiredToken(router: Router) {
    Swal.fire({
        title: 'Sesión expirada',
        text: 'Por favor, inicie sesión nuevamente',
        icon: 'error',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    }).then(() => {
        router.navigate(['/login']);
    });
}